<div class="row devOptions"  *ngIf="showDevOptions&&devOptionsRight">

        <div class="p-4 w-100">
            <div class="w-100">
                <h4 class="ml-3" style="font-weight: 600">{{'common_all_decode' | i18n}} </h4>
                <i class="fa fa-window-minimize margin-top-10 margin-right-8" (click)="showDevOptions=false"  (keydown.enter)="showDevOptions=false" style="cursor: pointer; position: absolute; right: 10px; top: 5px;"></i>
            </div>
            <div class="clearfix"></div>
            <div class="w-100" style="font-size: 14px;">
                <textarea class="decodeTextArea m-3" id="encrypted" placeholder="{{'common_all_encryptedData' | i18n}}"></textarea>
                <textarea class="decodeTextArea m-3" id="decrypted" placeholder="{{'common_all_result' | i18n}}" disabled></textarea>
            </div>
            <hr>
            <div class="col-sm-12 text-right mb-4">
              <footer>
                <button title="{{'common_clear' | i18n}}" (click)="clear()"
                  class="itemEditButton"  style="font-size: 14px;">{{'common_clear' | i18n}}</button>
                <button title="{{'common_submit' | i18n}}" (click)="decode()" type="button"
                  class="itemEditButton ml-4" style="font-size: 14px;"><i class="fa fa-spinner fa-spin"
                    *ngIf="addStatus"></i>{{'common_submit' | i18n}}</button>
              </footer>
            </div>
        </div>

  </div>
<div class="page-footer theme-bg-color w-100">
    <div class="row my-2 mx-1">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-0">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-8">
                <div class="row">
                    <ul class="footerItems footerTextColor">
                        <li>
                            <span class="li-footer__copy-text">© {{year}} </span>
                            <span class="footerTxt">{{company}}</span>
                        </li>
                        <li class="footerContent">
                            <a href="https://www.io-market.com/AGB.pdf" target="_blank"> <span class="li-footer__copy-text">{{'common_all_terms_and_conditions' | i18n}}</span></a>

                        </li>
                        <li class="footerContent">
                            <a href="https://www.io-market.com/ADV.pdf" target="_blank"> <span class="li-footer__copy-text">{{'common_all_data_processing_agreement' | i18n}}</span></a>

                        </li>
                        <li class="footerContent" >
                            <a href="https://www.io-market.com/privacy_policy.pdf" target="_blank"><span class="li-footer__copy-text">{{'common_all_privacy_policy' | i18n}}</span></a>

                        </li>
                        <li class="footerContent">
                            <a href="https://www.io-market.com/impressum.pdf" target="_blank"> <span class="li-footer__copy-text">{{'common_all_legal_notices' | i18n}}</span></a>

                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 px-0 hidden-xs d-sm-none  d-md-none d-lg-block">
                <a title="{{'common_all_footer_devOptions' | i18n}}" *ngIf="devOptionsRight" (click)="openDevOption()" class="itemEditButton" id="reset-smart-widget" style="position: absolute;
                bottom: -22px;
                right: 5px;">
                    <span class="decode">{{'common_all_footer_devOptions' | i18n}}</span></a>
                
            </div> 
        </div>
    </div>
</div>